import { useMediaQuery } from "../../hooks/useMediaQuery.js";

import { EditorPanel } from "./EditorPanel.js";
import { EditorTabs } from "./EditorTabs.js";
import { PreviewView } from "./PreviewView.js";

/**
 * Top-level editor screen.
 *
 * Layout:
 * - Narrow (default, < 768px): tabs [Edit] [Preview]
 * - Wide (>= 768px): side-by-side editor (60%) + preview (40%)
 *
 * The editor instance is mounted exactly once — `useMediaQuery` picks the
 * layout — so undo history and selection survive across resize.
 */
export function EditorScreen() {
  const isWide = useMediaQuery("(min-width: 768px)");

  if (isWide) {
    return (
      <div className="flex h-full">
        <div className="basis-3/5 border-r border-[var(--tg-secondary-bg)]">
          <EditorPanel />
        </div>
        <div className="basis-2/5">
          <PreviewView />
        </div>
      </div>
    );
  }

  return <EditorTabs edit={<EditorPanel />} preview={<PreviewView />} />;
}
